// Runtime fix for text visibility issues
// Forces dark text on white backgrounds for accessibility

export const applyTextVisibilityFix = () => {
  // Find all elements with problematic light text colors
  const problematicColors = [
    'rgb(250, 250, 250)',
    'rgb(249, 249, 249)',
    'rgb(248, 248, 248)',
    'rgb(247, 247, 247)',
    'rgb(246, 246, 246)',
    'rgb(245, 245, 245)',
    '#fafafa',
    '#f9f9f9',
    '#f8f8f8',
    '#f7f7f7',
    '#f6f6f6',
    '#f5f5f5'
  ];

  const fixElement = (element) => {
    const computedStyle = window.getComputedStyle(element);
    const currentColor = computedStyle.color;
    
    // Check if the element has light text color or if it's in a card
    const isInCard = element.closest('[class*="Card"]') || element.closest('.Card');
    const isGarageTheme = document.body.classList.contains('garage-theme') || document.documentElement.classList.contains('garage-theme');
    const isDarkTheme = document.body.classList.contains('dark') || document.documentElement.classList.contains('dark');
    
    if (isInCard || isGarageTheme || isDarkTheme) {
      // Force dark color for all text in cards or themed environments
      element.style.setProperty('color', '#0a0a0a', 'important');
      console.log('Fixed text color for themed element:', currentColor, 'on element:', element);
    } else if (problematicColors.some(color => currentColor.includes(color.replace(/[\s()]/g, '')) || currentColor === color)) {
      // Force dark color for light colors
      element.style.setProperty('color', '#0a0a0a', 'important');
      console.log('Fixed light text color:', currentColor, 'on element:', element);
    }
  };

  // Check all elements in cards
  const cardSelectors = [
    '[class*="Card"]',
    '.Card',
    '[data-radix-collection-item]'
  ];

  cardSelectors.forEach(selector => {
    const cards = document.querySelectorAll(selector);
    cards.forEach(card => {
      // Fix the card itself
      fixElement(card);
      
      // Fix all children
      const allChildren = card.querySelectorAll('*');
      allChildren.forEach(fixElement);
    });
  });

  // Global check for any remaining problematic elements
  const allElements = document.querySelectorAll('*');
  allElements.forEach(element => {
    const computedStyle = window.getComputedStyle(element);
    const parentBg = window.getComputedStyle(element.parentElement || document.body).backgroundColor;
    
    // If text is light and background is light/white, fix it
    if (parentBg.includes('255, 255, 255') || parentBg.includes('rgb(255, 255, 255)')) {
      fixElement(element);
    }
  });
};

// Aggressive continuous fix for persistent issues
export const setupContinuousTextFix = () => {
  const aggressiveFix = () => {
    // Find ALL elements with problematic colors
    const allElements = document.querySelectorAll('*');
    let fixedCount = 0;
    
    allElements.forEach(element => {
      const computedStyle = window.getComputedStyle(element);
      const currentColor = computedStyle.color;
      
      // Check for problematic light colors
      if (currentColor.includes('250, 250, 250') || 
          currentColor.includes('249, 249, 249') || 
          currentColor.includes('248, 248, 248') ||
          currentColor.includes('rgb(250, 250, 250)') ||
          currentColor === 'rgb(250, 250, 250)') {
        
        element.style.setProperty('color', '#0a0a0a', 'important');
        fixedCount++;
      }
      
      // Extra check for card elements
      const isInCard = element.closest('[class*="Card"]') || element.closest('.Card');
      if (isInCard && (currentColor.includes('25') && currentColor.includes('rgb'))) {
        element.style.setProperty('color', '#0a0a0a', 'important');
        fixedCount++;
      }
    });
    
    if (fixedCount > 0) {
      console.log(`Fixed ${fixedCount} problematic text elements`);
    }
  };
  
  // Run aggressively every 500ms
  const interval = setInterval(aggressiveFix, 500);
  
  return () => clearInterval(interval);
};

// Auto-run fix when DOM changes
export const setupTextVisibilityObserver = () => {
  const observer = new MutationObserver((mutations) => {
    let hasChanges = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        hasChanges = true;
      }
    });
    
    if (hasChanges) {
      // Debounced fix application
      setTimeout(applyTextVisibilityFix, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return observer;
};

// Force fix on page load
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', applyTextVisibilityFix);
  window.addEventListener('load', applyTextVisibilityFix);
}